import { BuildProcess } from '@App/app/entities/processing/build-process.model';

export const sortByProgress = (_: unknown, __: unknown, a: BuildProcess, b: BuildProcess) => {
  return a.compareByProgress(b);
};

export const sortByNotifications = (
  userId: number | undefined,
  a: BuildProcess,
  b: BuildProcess,
): number => {
  if (!userId) {
    return 0;
  }
  return (
    +(a.subscribers.owner === userId) - +(b.subscribers.owner === userId) ||
    +a.subscribers.subscribers.includes(userId) - +b.subscribers.subscribers.includes(userId)
  );
};

export const buildTablePage = (count: number, pageSize: number, limit: number, offset: number) => ({
  count,
  pageSize,
  limit,
  offset,
});
